import {SuccessfulApiResponse} from "@eryxcoop/appyx-comm";
import DateAdapter from "../../adapters/DateAdapter";

export default class CustomerOnboardingResponse extends SuccessfulApiResponse {
    static defaultResponse() {
        return {
            object:
                {
                    'request':
                        {
                            'taxpayer_identification_number': '123456789',
                            'requester': 'lcuadrado@eryx.co',
                            'request_timestamp': '25-25-25 25:25:25',
                            'legal_entity': {
                                'business_name': 'Dunder Mifflin',
                                'fantasy_name': 'Dunder Mifflin',
                                'fiscal_address': 'Scranton 1234',
                                'city': 'Scranton',
                                'postal_code': '1234A',
                                'jurisdictions': ['BUENOS_AIRES'],
                            },
                            'contact_data': {
                                'collections_contact_name': 'Michael',
                                'collections_contact_email': 'm@m.m',
                                'collections_contact_area_number': '11',
                                'collections_contact_phone_number': '1111111111',
                                'orders_contact_name': 'Jim',
                                'orders_contact_email': 'j@j.j',
                                'orders_contact_area_number': '11',
                                'orders_contact_phone_number': '2222222222',
                            },
                            'commercial_terms': {
                                'price_list_code': "LPA",
                                'payment_term_code': "1",
                                'customer_group_code': "2",
                                'payment_method': 'Transferencia',
                                'segment': 'HORECA',
                                'horecaSubcategory': 'Otro'
                            },
                            'tax_data': {
                                'afip_registration_proof': "a_file",
                                'gross_income_tax_registration_proof': "a_file",
                                'cm01_form': "a_file",
                                'cm05_form': 'a_file',
                                'exemptions_certificate': 'a_file',
                                'non_withholding_certificate': 'a_file',
                                'raw_income': 'Inscripto',
                                'exemption_certificate_option': 'si',
                                'provinces_perceptions': ['LA RIOJA', 'BUENOS AIRES'],
                                'non_withholding_certificate_option': 'no',
                                'income_tax': 'Transferencia',
                                'iva_condition': 'Responsable Inscripto',
                            },
                            'finance_data': {
                                'finance_observations': "an observation",
                                'nosis_document': "a_file",
                            },
                            'delivery_site_onboarding_requests': [
                                {
                                    'id': 1,
                                    'name': 'Boulan',
                                    'location': {
                                        'address': 'Ugarteche 123',
                                        'city': 'CABA',
                                        'postal_code': '1425',
                                        'latitude': null,
                                        'longitude': null,
                                    },
                                    'jurisdiction': 'Capital Federal',
                                    'zone': 'CABA',
                                    'exceptional_frequency': ['LUN'],
                                    'preferred_delivery_time_range': 'de 7 a 14 hs',
                                },
                            ],
                            'user_onboarding_requests': [
                                {
                                    'id': 1,
                                    'email': 'asda@asdas.com',
                                    'delivery_site_onboarding_requests': [
                                        {
                                            'id': 1,
                                            'name': 'Boulan',
                                            'location': {
                                                'address': 'Ugarteche 123',
                                                'city': 'CABA',
                                                'postal_code': '1425',
                                                'latitude': null,
                                                'longitude': null,
                                            },
                                            'jurisdiction': 'Capital Federal',
                                            'zone': 'CABA',
                                            'exceptional_frequency': ['LUN'],
                                            'preferred_delivery_time_range': 'de 7 a 14 hs',
                                        },
                                    ],
                                    'roles': ['FRONTOFFICE_OPERATIONAL_ROLE'],
                                },
                            ]
                        },
                    'state': 'PENDING',
                    'close_datetime': '25-25-25 25:25:25',
                    'logistics_authorization': true,
                    'commercial_authorization': true,
                    'finance_authorization': false,
                    'tax_authorization': false,
                    'configuration': {
                        'mandatory_fields': ['_taxpayer_identification_number', '_business_name', '_fantasy_name',
                            '_fiscal_address', '_city', '_postal_code', '_jurisdictions', '_segment',
                            '_collections_contact_name', '_collections_contact_email',
                            '_collections_contact_area_number', '_collections_contact_phone_number',
                            '_orders_contact_name', '_orders_contact_email', '_orders_contact_area_number',
                            '_orders_contact_phone_number', '_price_list_code', '_payment_term_code', '_payment_method',
                            '_customer_group_code', '_raw_income', '_exemption_certificate_option',
                            '_non_withholding_certificate_option', '_income_tax',
                            '_iva_condition',
                            '_delivery_site_onboarding_requests', '_user_onboarding_requests'],
                        'readonly_fields': [],
                    },
                    'authorizations': {
                        'commercial_authorization': 'PENDING',
                        'logistics_authorization': 'PENDING',
                        'finance_authorization': 'PENDING',
                        'tax_authorization': 'PENDING',
                    },
                    'authorizations_observations': {
                        'commercial_authorization': '',
                        'logistics_authorization': '',
                        'finance_authorization': 'Falta constancia de CBU',
                        'tax_authorization': '',
                    },
                },
            errors: [],
        }
    }

    customerOnboarding() {
        const customerOnboarding = this.content()
        return {
            'request':
                {
                    'taxpayerIdentificationNumber': customerOnboarding.request.taxpayer_identification_number,
                    'requester': customerOnboarding.request.requester,
                    'requestTimestamp': this._adaptDatetime(customerOnboarding.request.request_timestamp),
                    'legalEntity': this._legalEntityData(customerOnboarding),
                    'contactData': this._contactData(customerOnboarding),
                    'commercialTerms': this._commercialTerms(customerOnboarding),
                    'taxData': this._taxData(customerOnboarding),
                    'financeData': this._financeData(customerOnboarding),
                    'deliverySitesOnboardingRequests': this._deliverySiteOnBoardingRequests(customerOnboarding),
                    'userOnboardingRequests': this._userOnBoardingRequests(customerOnboarding),
                },
            'state': this._adaptState(customerOnboarding.state),
            'closeDatetime': this._adaptDatetime(customerOnboarding.close_datetime),
            'logisticsAuthorization': customerOnboarding.logistics_authorization,
            'commercialAuthorization': customerOnboarding.commercial_authorization,
            'financeAuthorization': customerOnboarding.finance_authorization,
            'taxAuthorization': customerOnboarding.tax_authorization,
            'configuration': this._configuration(customerOnboarding),
            'authorizations': this._authorizations(customerOnboarding),
            'authorizationsObservations': this._authorizationsObservations(customerOnboarding),
        }
    }

    _legalEntityData(customerOnboarding) {
        return {
            'taxpayerIdentificationNumber': customerOnboarding.request.legal_entity.taxpayer_identification_number,
            'businessName': customerOnboarding.request.legal_entity.business_name,
            'fantasyName': customerOnboarding.request.legal_entity.fantasy_name,
            'fiscalAddress': customerOnboarding.request.legal_entity.fiscal_address,
            'city': customerOnboarding.request.legal_entity.city,
            'postalCode': customerOnboarding.request.legal_entity.postal_code,
            'jurisdictions': customerOnboarding.request.legal_entity.jurisdictions || [],
        };
    }

    _contactData(customerOnboarding) {
        return {
            'collectionsContactName': customerOnboarding.request.contact_data.collections_contact_name,
            'collectionsContactEmail': customerOnboarding.request.contact_data.collections_contact_email,
            'collectionsContactAreaNumber': customerOnboarding.request.contact_data.collections_contact_area_number,
            'collectionsContactPhoneNumber': customerOnboarding.request.contact_data.collections_contact_phone_number,
            'ordersContactName': customerOnboarding.request.contact_data.orders_contact_name,
            'ordersContactEmail': customerOnboarding.request.contact_data.orders_contact_email,
            'ordersContactAreaNumber': customerOnboarding.request.contact_data.orders_contact_area_number,
            'ordersContactPhoneNumber': customerOnboarding.request.contact_data.orders_contact_phone_number,
        };
    }

    _commercialTerms(customerOnboarding) {
        return {
            'priceListCode': customerOnboarding.request.commercial_terms.price_list_code,
            'paymentTermCode': customerOnboarding.request.commercial_terms.payment_term_code,
            'customerGroupCode': customerOnboarding.request.commercial_terms.customer_group_code,
            'paymentMethod': customerOnboarding.request.commercial_terms.payment_method,
            'segment': customerOnboarding.request.commercial_terms.segment,
            'horecaSubcategory': customerOnboarding.request.commercial_terms.horeca_subcategory,
        };
    }
    
    _taxData(customerOnboarding) {
        return {
            'afipRegistrationProof': customerOnboarding.request.tax_data.afip_registration_proof,
            'grossIncomeTaxRegistrationProof': customerOnboarding.request.tax_data.gross_income_tax_registration_proof,
            'cm01form': customerOnboarding.request.tax_data.cm01_form,
            'cm05form': customerOnboarding.request.tax_data.cm05_form,
            'exemptionsCertificate': customerOnboarding.request.tax_data.exemptions_certificate,
            'nonWithholdingCertificate': customerOnboarding.request.tax_data.non_withholding_certificate,
            'rawIncome': customerOnboarding.request.tax_data.raw_income,
            'exemptionCertificateOption': customerOnboarding.request.tax_data.exemption_certificate_option,
            'provincesPerceptions': customerOnboarding.request.tax_data.provinces_perceptions,
            'nonWithholdingCertificateOption': customerOnboarding.request.tax_data.non_withholding_certificate_option,
            'incomeTax': customerOnboarding.request.tax_data.income_tax,
            'ivaCondition': customerOnboarding.request.tax_data.iva_condition,
        };
    }

    _financeData(customerOnboarding) {
        return {
            'financeObservations': customerOnboarding.request.finance_data.finance_observations,
            'nosisDocument': customerOnboarding.request.finance_data.nosis_document,
        };
    }

    _deliverySiteOnBoardingRequests(customerOnboarding) {
        return this._deliverySiteOnBoardingRequestsFrom(customerOnboarding.request.delivery_site_onboarding_requests)
    }

    _deliverySiteOnBoardingRequestsFrom(deliverySiteOnboardingRequests) {
        return deliverySiteOnboardingRequests.map(deliverySiteOnboardingRequest => {
            return {
                'id': deliverySiteOnboardingRequest.id,
                'name': deliverySiteOnboardingRequest.name,
                'address': deliverySiteOnboardingRequest.location.address,
                'city': deliverySiteOnboardingRequest.location.city,
                'postalCode': deliverySiteOnboardingRequest.location.postal_code,
                'jurisdiction': deliverySiteOnboardingRequest.jurisdiction,
                'zone': deliverySiteOnboardingRequest.zone,
                'preferredDeliveryTimeRange': deliverySiteOnboardingRequest.preferred_delivery_time_range,
                'exceptionalFrequency': deliverySiteOnboardingRequest.exceptional_frequency,
            }
        })
    }

    _userOnBoardingRequests(customerOnboarding) {
        return customerOnboarding.request.user_onboarding_requests.map(userOnBoardingRequest => {
            return {
                id: userOnBoardingRequest.id,
                email: userOnBoardingRequest.email,
                deliverySiteOnboardingRequests: this._deliverySiteOnBoardingRequestsFrom(userOnBoardingRequest.delivery_site_onboarding_requests),
                roles: userOnBoardingRequest.roles,
            }
        })
    }

    _configuration(customerOnboarding) {
        return {
            mandatoryFields: customerOnboarding.configuration.mandatory_fields,
            readonlyFields: customerOnboarding.configuration.readonly_fields,
        }
    }

    _authorizations(customerOnboarding) {
        if (customerOnboarding.authorizations) {
            return {
                commercialAuthorizationState: customerOnboarding.authorizations.commercial_authorization,
                logisticsAuthorizationState: customerOnboarding.authorizations.logistics_authorization,
                financeAuthorizationState: customerOnboarding.authorizations.finance_authorization,
                taxAuthorizationState: customerOnboarding.authorizations.tax_authorization,
            }
        }
        return {
                commercialAuthorizationState: null,
                logisticsAuthorizationState: null,
                financeAuthorizationState: null,
                taxAuthorizationState: null,
        }
    }

    _authorizationsObservations(customerOnboarding) {
        if (customerOnboarding.authorizations_observations) {
            return {
                commercialAuthorizationObservations: customerOnboarding.authorizations_observations.commercial_authorization,
                logisticsAuthorizationObservations: customerOnboarding.authorizations_observations.logistics_authorization,
                financeAuthorizationObservations: customerOnboarding.authorizations_observations.finance_authorization,
                taxAuthorizationObservations: customerOnboarding.authorizations_observations.tax_authorization,
            }
        }
        return {
                commercialAuthorizationObservations: '',
                logisticsAuthorizationObservations: '',
                financeAuthorizationObservations: '',
                taxAuthorizationObservations: '',
        }
    }

    _adaptDatetime(datetime) {
        if (datetime === null) {
            return '-';
        } else {
            return DateAdapter.adaptDatetime(datetime)
        }
    }

    _adaptState(value) {
        if (value === "PENDING") {
            return 'Pendiente';
        }
        if (value === "PROCESSING_BY_AREA_STATE") {
            return 'Proceso de Area';
        }
        if (value === "PENDING_ERP_LOAD") {
            return 'Pendiente de carga en el ERP';
        }
        if (value === "CLOSED") {
            return 'Cerrado';
        }
    }
}
